import React, { Component } from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { reduxForm, Field, getFormSyncErrors } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { __ } from '../../utilities';
import validate from './validate';

import Loader from '../../components/Loader';
import renderInput from '../../components/Input/redux-form';
import Button from '../../components/Button';
import Label from '../../components/Label';
import FormGroup from '../../components/FormGroup';

export const FORM_NAME = 'register_form';
export const NUMBER_PLACEHOLDER = '+421 XXX XXX XXX';

const Wrapper = styled.form`
  padding: ${rem(30)} 1.125rem;
  background-color: #fff;
  ${({ theme }) => theme.media.sm`
    padding: ${rem(35)} ${rem(50)};
  `};
  box-shadow: ${({ theme }) => theme.shadow};
  margin-bottom: ${rem(10)};
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  ${({ theme }) => theme.media.sm`  
    flex-direction: row;
  `};
`;

export const Col = styled.div`
  width: calc(100% - ${rem(10)});
  color: ${({ theme }) => theme.color.font.secondary};
  ${({ theme }) => theme.media.sm`  
    width: calc(50% - ${rem(10)});    
  `};
`;

const ButtonWrapper = styled.div`
  margin-top: ${rem(20)};
  display: flex;
  justify-content: center;
`;

class Form extends Component {
  render() {
    const { handleSubmit, isFetching } = this.props;
    if (isFetching) {
      return (
        <Wrapper>
          <Loader size="xxl" text={__('Prosím počkajte ...')} />
        </Wrapper>
      );
    }
    return (
      <Wrapper onSubmit={handleSubmit}>
        <Row>
          <Col>
            <FormGroup>
              <Label required>{__('Meno')}</Label>
              <Field name="username" type="text" component={renderInput} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label required>{__('Priezvisko')}</Label>
              <Field name="surname" type="text" component={renderInput} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label required>{__('Email')}</Label>
              <Field name="email" type="email" component={renderInput} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label required>{__('Tel. číslo')}</Label>
              <Field
                name="contact"
                type="tel"
                component={renderInput}
                placeholder={NUMBER_PLACEHOLDER}
              />
              <span>
                {__('Požadovaný formát je ')}
                {NUMBER_PLACEHOLDER}
              </span>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label required>{__('Prihlasovacie meno')}</Label>
              <Field name="login" type="text" component={renderInput} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label required>{__('Heslo')}</Label>
              <Field
                name="password_client"
                type="password"
                component={renderInput}
              />
            </FormGroup>
          </Col>
        </Row>
        <ButtonWrapper>
          <Button type="button" onClick={this.props.onClickBack}>
            {__('Späť na prihlásenie')}
          </Button>
          <Button type="submit" primary>
            {__('Registrovať')}
          </Button>
        </ButtonWrapper>
      </Wrapper>
    );
  }
}

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onClickBack: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

const withReduxForm = reduxForm({
  form: FORM_NAME,
  validate,
})(Form);

const mapStateToProps = state => {
  return {
    formErrors: getFormSyncErrors(FORM_NAME)(state),
  };
};

export default connect(mapStateToProps)(withReduxForm);



// WEBPACK FOOTER //
// ./src/containers/Login/registrationForm.js